module.exports = __webpack_public_path__ + "static/media/t-2-q-1.df2ad948.jpg";